/*
Government Purpose Rights (“GPR”)
Contract No.  W911NF-14-D-0005
Contractor Name:   University of Southern California
Contractor Address:  3720 S. Flower Street, 3rd Floor, Los Angeles, CA 90089-0001
Expiration Date:  Restrictions do not expire, GPR is perpetual
Restrictions Notice/Marking: The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(2) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract.  No restrictions apply after the expiration date shown above. Any reproduction of the software or portions thereof marked with this legend must also reproduce the markings. (see: DFARS 252.227-7014(f)(2)) 
No Commercial Use: This software shall be used for government purposes only and shall not, without the express written permission of the party whose name appears in the restrictive legend, be used, modified, reproduced, released, performed, or displayed for any commercial purpose or disclosed to a person other than subcontractors, suppliers, or prospective subcontractors or suppliers, who require the software to submit offers for, or perform, government contracts.  Prior to disclosing the software, the Contractor shall require the persons to whom disclosure will be made to complete and sign the non-disclosure agreement at 227.7103-7.  (see DFARS 252.227-7025(b)(2))
*/

import {
  RESOURCE,
  VALIDATION,
} from "@ictlearningsciences/pal3-core/api/queries";

export const LESSON_QUERY = `
  id
  alias
  name
  desc
  type
  displayType
  hidden
  ord
  estMinLow
  estMinHigh
  downloadable
  topic
  randomizeResources
  remediationScore
  remedialLessons
  remedialRequirements {
    type
    match
    matchValidValues
    greaterPreferred
    greaterCompared
  }
  traitRequirements {
    type
    match
    matchValidValues
    greaterPreferred
    greaterCompared
  }
  resources {
    ${RESOURCE}
  }
  reflectionValidation {
    ${VALIDATION}
  }
`;

export const TOPIC_QUERY = `
  id
  alias
  name
  desc
  hidden
  ord
  recommender
  attributeRelevance {
    name
    value
  }
  knowledgeComponents {
    kc
    relevance
  }
  prerequisiteTopics {
    id
    name
    knowledgeComponents {
      kc
      relevance
    }
  }
  requiredLessons
`;

export const FOCUS_QUERY = `
  id
  name
  desc
`;

export const GOAL_QUERY = `
  id
  alias
  name
  hidden
  ord
  desc
  presurvey
  postsurvey
  plans {
    id
    alias
    name
  }
  learnerTypes {
    id
    alias
    name
    characteristics
  }
  xapiSubscribers {
    url
    accessHeaders {
      name
      value
    }
  }
  recommenderOverride {
    headers {
      name
      value
    }
    masteryUrl
    lessonRecUrl
    masteryFunction
    lessonRecFunction
  }
`;
